import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import api from '../services/api';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const submit = async e => {
    e.preventDefault();
    try {
      const { data } = await api.post('/auth/login', { email, password });
      localStorage.setItem('token', data.token);
      localStorage.setItem('user', JSON.stringify(data.user));
      navigate('/');
    } catch (err) { setError(err.response?.data?.error || 'Login failed'); }
  };

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', background: '#6366f1' }}>
      <form onSubmit={submit} style={{ background: '#fff', padding: 40, borderRadius: 12, width: 380, boxShadow: '0 8px 32px rgba(0,0,0,.15)' }}>
        <h1 style={{ marginBottom: 8, fontSize: 28 }}>🔲 QR App</h1>
        <p style={{ color: '#666', marginBottom: 24 }}>Sign in to your account</p>
        {error && <p style={{ color: 'red', marginBottom: 12 }}>{error}</p>}
        <input value={email} onChange={e => setEmail(e.target.value)} placeholder="Email" type="email" required
          style={{ width: '100%', padding: 12, marginBottom: 12, border: '1px solid #ddd', borderRadius: 8, fontSize: 14 }} />
        <input value={password} onChange={e => setPassword(e.target.value)} placeholder="Password" type="password" required
          style={{ width: '100%', padding: 12, marginBottom: 20, border: '1px solid #ddd', borderRadius: 8, fontSize: 14 }} />
        <button type="submit" style={{ width: '100%', padding: 12, background: '#6366f1', color: '#fff', border: 'none', borderRadius: 8, fontSize: 16, cursor: 'pointer', fontWeight: 600 }}>Sign In</button>
        <p style={{ textAlign: 'center', marginTop: 16, color: '#666' }}>No account? <Link to="/signup" style={{ color: '#6366f1' }}>Sign up</Link></p>
      </form>
    </div>
  );
}
